var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCardSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 30.7647,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7371 22.2742C21.17 23.5951 19.1372 24.3925 16.9158 24.3925C11.9594 24.3925 7.94141 20.4223 7.94141 15.5249C7.94141 10.6274 11.9594 6.65723 16.9158 6.65723C19.1372 6.65723 21.17 7.45465 22.7371 8.77559C24.3042 7.45465 26.3371 6.65723 28.5584 6.65723C33.5148 6.65723 37.5328 10.6274 37.5328 15.5249C37.5328 20.4223 33.5148 24.3925 28.5584 24.3925C26.3371 24.3925 24.3042 23.5951 22.7371 22.2742Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7373 22.2742C24.6669 20.6477 25.8905 18.2275 25.8905 15.5249C25.8905 12.8223 24.6669 10.4021 22.7373 8.77559C24.3044 7.45465 26.3372 6.65723 28.5586 6.65723C33.515 6.65723 37.533 10.6274 37.533 15.5249C37.533 20.4223 33.515 24.3925 28.5586 24.3925C26.3372 24.3925 24.3044 23.5951 22.7373 22.2742Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7371 22.2739C24.6667 20.6474 25.8903 18.2272 25.8903 15.5246C25.8903 12.8221 24.6667 10.4019 22.7371 8.77539C20.8075 10.4019 19.584 12.8221 19.584 15.5246C19.584 18.2272 20.8075 20.6474 22.7371 22.2739Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardSm);
export default __webpack_public_path__ + "static/media/masterCardSm.ce0622f7.svg";
export { ForwardRef as ReactComponent };